
import jQuery from 'jquery';
import svg4everybody from 'svg4everybody';
import PerfectScrollbar from 'perfect-scrollbar';

window.$ = jQuery;
window.jQuery = jQuery;

require('accordionjs')
require('slick-carousel');
require('magnific-popup');
require('simplebar');
require('selectize');
require('sticky-kit/dist/sticky-kit.min.js');
require('svg4everybody');

window.svg4everybody = svg4everybody;
window.PerfectScrollbar = PerfectScrollbar;

require('./main');
require('./modules/partners');
require('./modules/contacts');
